import { TextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import React from 'react';

interface CustomTextFieldProps extends Omit<MuiTextFieldProps, 'label'> {
	label?: string;
	placeholder?: string;
	value: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	required?: boolean;
	error?: boolean;
	helperText?: React.ReactNode;
}

export default function TextFieldProps({
	label = 'Label',
	placeholder = 'Enter value',
	fullWidth = true,
	onChange,
	value,
	required = false,
	error = false,
	helperText = '',
	...rest
}: CustomTextFieldProps) {
	return (
		<TextField
			label={label}
			placeholder={placeholder}
			fullWidth={fullWidth}
			value={value}
			onChange={onChange}
			required={required}
			error={error}
			size="small"
			helperText={helperText}
			sx={{
				gridColumn: '1',
				fontFamily: 'Poppins',
				'& .MuiInputBase-input::placeholder': {
					fontFamily: 'Poppins',
				},
			}}
			InputLabelProps={{
				shrink: true,
				sx: {
					color: '#658E81',
					// bgcolor: 'white',
					fontFamily: 'Poppins',
				},
			}}
			InputProps={{
				style: { fontFamily: 'Poppins' },
			}}
			FormHelperTextProps={{
				style: { fontFamily: 'Poppins' },
			}}
			{...rest}
		/>
	);
}
